export default __webpack_public_path__ + "static/media/sound1.2721cd73.mp3";